module.exports = __webpack_public_path__ + "media/images/youtube@2x-bb0c51ab28cbcc76228c2c65bd12575f.png";